import { Reveal, SectionHead } from "@/components/Reveal";
import { Marquee } from "@/components/Marquee";
import { BENEFITS } from "@/data/content";
import { Check } from "lucide-react";

export const Benefits = () => (
  <section className="relative overflow-hidden border-y border-white/5 bg-[#0c1319] py-24 md:py-32" data-testid="benefits-section">
    <div className="absolute inset-x-0 top-6 opacity-70">
      <Marquee text="Zie hitte voordat het vuur wordt —" />
    </div>
    <div className="relative mx-auto max-w-7xl px-4 pt-24 sm:px-6 lg:px-10">
      <SectionHead nr="08" overline="Voordelen" title="Meer inzicht in warmteontwikkeling op uw terrein" />
      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {BENEFITS.map((benefit, i) => (
          <Reveal key={benefit} delay={(i % 3) * 0.08}>
            <div className="flex items-start gap-4 rounded-xl border border-white/10 bg-[#090D10]/70 p-5 backdrop-blur-md transition-[border-color] duration-500 hover:border-[#2B9FD7]/40">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#2B9FD7]/15 text-[#62C3F0]">
                <Check size={14} strokeWidth={2.5} />
              </span>
              <p className="text-sm font-medium leading-relaxed text-[#F5F7F9]">{benefit}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
